import React from 'react';

export default function CurrentLocationIcon({
  width = 24,
  height = 24,
  fill = '#ED1C24',
  className = '',
}: React.ComponentProps<'svg'>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_22912_16997)">
        <path
          d="M12 8.59961C9.79 8.59961 8 10.3896 8 12.5996C8 14.8096 9.79 16.5996 12 16.5996C14.21 16.5996 16 14.8096 16 12.5996C16 10.3896 14.21 8.59961 12 8.59961ZM20.94 11.5996C20.48 7.42961 17.17 4.11961 13 3.65961V1.59961H11V3.65961C6.83 4.11961 3.52 7.42961 3.06 11.5996H1V13.5996H3.06C3.52 17.7696 6.83 21.0796 11 21.5396V23.5996H13V21.5396C17.17 21.0796 20.48 17.7696 20.94 13.5996H23V11.5996H20.94ZM12 19.5996C8.13 19.5996 5 16.4696 5 12.5996C5 8.72961 8.13 5.59961 12 5.59961C15.87 5.59961 19 8.72961 19 12.5996C19 16.4696 15.87 19.5996 12 19.5996Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}
